import { render, staticRenderFns } from "./aboutUS.vue?vue&type=template&id=04c4c934&"
import script from "./aboutUS.vue?vue&type=script&lang=js&"
export * from "./aboutUS.vue?vue&type=script&lang=js&"
import style0 from "./aboutUS.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports